import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  AUTH_SPLIT_LAYOUT_CONFIG,
  AuthSplitLayoutConfig,
} from '../../components/layouts/auth-split-layout/auth-split-layout.interface';

@Component({
  selector: 'aura-landing-projection',
  templateUrl: './landing-projection.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  host: {
    class: 'flex flex-col flex-1 w-full h-full min-h-full',
  },
})
export class AuraLandingProjectionComponent {
  private readonly config = inject<AuthSplitLayoutConfig | null>(AUTH_SPLIT_LAYOUT_CONFIG, {
    optional: true,
  });

  readonly appName = input<string>();
  readonly logoUrl = input<string>();
  readonly logoAlt = input<string>();
  readonly logoLink = input<string>();

  protected readonly resolvedAppName = computed(() =>
    (this.appName() ?? this.config?.appName ?? 'ETXE').toUpperCase(),
  );

  protected readonly resolvedLogoUrl = computed(
    () => this.logoUrl() ?? this.config?.logoUrl ?? '/images/logo/logo.svg',
  );

  protected readonly resolvedLogoAlt = computed(
    () => this.logoAlt() ?? this.config?.logoAlt ?? this.resolvedAppName(),
  );

  protected readonly resolvedLogoLink = computed(() => this.logoLink() ?? this.config?.logoLink ?? '/');
}
